import { FC, useEffect, useState } from 'react';

import { Box, useMediaQuery } from '@mui/material';
import { IYearPerformance } from 'portfolio3/features/performance/containers/PerformanceContainer.types';
import { emitYMEvent } from 'portfolio3/features/yandexMetrika';
import { commonTheme } from 'portfolio3/styles/theme';

import ShowMore from '../../common/ShowMore';
import { AverageResultTile, SubjectResultTile } from './tile';

import './index.scss';

interface IPerformanceTilesProps {
  yearPerformance: IYearPerformance;
  selectedSubjectId: number | undefined;
  isInteger?: boolean;
  onSelectSubject: (id: number) => void;
}

const PerformanceTiles: FC<IPerformanceTilesProps> = ({
  yearPerformance,
  selectedSubjectId,
  isInteger = false,
  onSelectSubject,
}) => {
  const isMobile = useMediaQuery(commonTheme.breakpoints.down('commonSm'));

  const { averageMarkFive, subjectsPerformance } = yearPerformance;

  const totalSubjectsCount = subjectsPerformance?.length ?? 0;

  return (
    <div className="performance-tiles-wrapper">
      <div className="performance-tiles">
        <div className="performance-tiles__results-container">
          {averageMarkFive !== undefined && <AverageResultTile doughuntValue={averageMarkFive} />}
          {subjectsPerformance && totalSubjectsCount > 0 && (
            <div className="performance-tiles__subject-results">
              {subjectsPerformance.map(({ subjectId, subjectName, markValue, nonMarkValue }) => (
                <div
                  key={subjectId}
                  // onClick={() => onSelectSubject(id)}
                >
                  <SubjectResultTile
                    doughnutValue={markValue}
                    altValue={nonMarkValue}
                    description={subjectName}
                    selected={subjectId === selectedSubjectId}
                    isInteger={isInteger}
                  />
                </div>
              ))}
            </div>
          )}
        </div>

        {/* <div className="performance-tiles__details-container">
          <SubjectThemesContainer selectedSubjectId={selectedSubjectId} yearPerformance={yearPerformance} />
        </div> */}
      </div>
      {/* {isMobile && (
        <Box marginTop="12px">
          <SubjectHint />
        </Box>
      )} */}
    </div>
  );
};

export default PerformanceTiles;
